const appConfig = {
    apiPrefix: '/api',
    // REACT_APP_API_URL / REACT_APP_APP_URL are baked in at build time.
    // Set them in Railway's environment variables for the frontend service;
    // falls back to localhost for local dev when unset.
    apiURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
    appURL: process.env.REACT_APP_APP_URL || 'http://localhost:3000',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    unVerifiedEntryPath: '/verify',
    tourPath: '/',
    enableMock: false,
    // defaultAdminID: 3,
    defaultAdminID: 1,
}

export const getTransactionHashURL = (transactionHash) => {
    let url;
    const transactionHashURL = "https://tronscan.org/#/transaction/";
    try {
        url = new URL(transactionHash);
    } catch (_) {
        return transactionHashURL + transactionHash;
    }

    if (url.protocol === 'http:' || url.protocol === 'https:') {
        // if URL, return original hash
        return transactionHash;
    }

    return transactionHashURL + transactionHash;
};

export default appConfig